<script lang="ts">
    import {Link} from 'svelte-routing'
    import Slots from 'src/components/cabinet/inventory/components/egg/Slots.svelte'
    import informationIcon from './info.svg'
    import background from 'src/components/main/marketplace/components/nft-cards/background.svg'
    import plus from 'src/components/main/marketplace/components/nft-cards/plus.svg'
    import star from 'src/components/main/nft/components/nft-info/star.svg'
    import headIcon from './head.svg'
    import bodyIcon from './body.svg'
    import tailIcon from './tail.svg'
    import {getEgg, openLootbox} from 'src/components/cabinet/#services/inventory'
    import {showAlert} from 'src/components/#common/alert/store'
    import { createEventDispatcher } from 'svelte'

    export let productId

    const dispatch = createEventDispatcher()

    let jelloActive = true
    let crashActive = false
    let slotsActive = false
    let slotsMove = false
    let nftCardActive = false

    let elements = ['crystal', 'dark', 'earth', 'electrical', 'fire', 'iron', 'light', 'water', 'wind']

    let rarityList = { 0: 'Uncommon', 1: 'Rare', 2: 'Epic', 3: 'Legendary', 4: 'Supreme' }

    getEgg.send({ data: { productId } })

    async function openLootboxHandler() {
        try {
            openLootbox.reset()
            await openLootbox.request({ data: { productId } })

            dispatch('opened')

            jelloActive = false
            crashActive = true

            setTimeout(() => {
                slotsActive = true
            }, 1900)

            setTimeout(() => {
                crashActive = false
            }, 2000)

            setTimeout(() => {
                slotsMove = true
                nftCardActive = true
            }, 10000)
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        }
    }
</script>

{#if !$getEgg.hasValue && $getEgg.loading}
    Loading...
{:else if !$getEgg.hasValue && $getEgg.error}
    An Error Occurred, Please Try Again Later
{:else if $getEgg.hasValue}
    <div class="hatching-wrapper">
        {#if jelloActive}
            <img src="/images/eggs/orig/egg-{productId.slice(-1)}.png" class="nft-img jello" alt="">
            <button class="btn btn-primary hatching-btn" on:click={openLootboxHandler}><span>Hatching</span></button>
        {:else if crashActive || slotsActive}
            {#if crashActive}
                <div class="egg-crash-wrapper">
                    <video autoplay loop class="nft-img crash">
                        <source src="/videos/egg-{productId.slice(-1)}-crash.mp4" type="video/mp4">
                    </video>
                </div>
            {/if}
            {#if slotsActive && $openLootbox.hasValue}
                <Slots elements={$openLootbox.value?.elements} move={slotsMove} rarity={$openLootbox.value?.rarity}/>
            {/if}
            {#if nftCardActive && $openLootbox.hasValue}
                <Link to="inventory/units/" class="nft-card big-nft-card card-{$openLootbox.value?.rarity}" style="--Background:url({background});">
                    <div class="flare"></div>
                    <div class="rarity rarity-id-{$openLootbox.value?.rarity}">
                        <div class="rarity-value notranslate">{rarityList[$openLootbox.value?.rarity]}</div>
                        <div class="level notranslate"><span>LVL.{$openLootbox.value?.level}</span></div>
                        <div class="image">
                            <img src="{($openLootbox.value?.image).replace('orig', 'thumb')}" alt="nft">
                        </div>
                        <div class="elements">
                            {#if $openLootbox.value?.elements && $openLootbox.value?.elements.length}
                                {#each $openLootbox.value?.elements as item}
                                    {#if item.element}
                                        <img src="/images/elements/{item.element}-{item.subElement}.svg">
                                    {/if}
                                {/each}
                            {/if}
                        </div>
                    </div>
                    <div class="stars">
                        {#each {length: $openLootbox.value?.rarity + 2} as _, i}
                            {#if i < 5}
                                <img src="{star}" alt="star">
                            {/if}
                        {/each}
                        {#if $openLootbox.value?.rarity === 4}
                            <img src="{plus}" class="plus" alt="plus">
                        {/if}
                    </div>
                    <div class="name notranslate">{$openLootbox.value?.name}</div>
                </Link>
            {/if}
            <div class="match-text">Match same elements to increase rarity
                <div class="hatching-tooltip">
                    <img src="{informationIcon}" class="hatching-info-icon" alt="">
                    <div class="tooltip">The unit consists of 3 parts, head, body and tail. There are 9 elements of 3 types.
                        Each part has 27 variations. A total of 19,683 unique NFT units.<br><br>
                        Probably drop:<br>
                        Rare 69,1% (3 different elements)<br>
                        Epic 29.53% (2 same elements)<br>
                        Legendary 1.23% (3 same elements)<br>
                        Supreme 0.137% (3 same elements + same types)
                    </div>
                </div>
            </div>
        {/if}
    </div>
{/if}

<img src={headIcon} alt="" style="display: none;">
<img src={bodyIcon} alt="" style="display: none;">
<img src={tailIcon} alt="" style="display: none;">
<video src="/videos/egg-{productId.slice(-1)}-crash.mp4" preload="auto" controls autoplay style="display: none;"></video>
{#each elements as element}
    <img src="/images/elements/{element}-0.svg" alt="" style="display: none;">
    <img src="/images/elements/{element}-1.svg" alt="" style="display: none;">
    <img src="/images/elements/{element}-2.svg" alt="" style="display: none;">
{/each}
{#if $openLootbox.hasValue && $openLootbox.value?.image}
    <img src="{($openLootbox.value?.image).replace('orig', 'thumb')}" alt="" style="display: none;">
{/if}

<style>
    .match-text {
        font-size: 18px;
        text-align: center;
        padding: 10px 0;
        position: absolute;
        bottom: 0;
        width: 100%;
    }

    .hatching-wrapper :global(.nft-card) {
        width: 230px;
        margin: 0 auto 10px;
        background: #363a4e;
        border-radius: 10px;
        border: 1px solid #61758A;
        display: block;
        text-decoration: none;
        position: relative;
        padding: 0;
        transition: .25s;
        overflow: hidden;
    }

    .hatching-wrapper :global(.big-nft-card) {
        width: 300px;
    }

    .hatching-wrapper :global(a.nft-card.big-nft-card:hover) {
        transform: none;
    }

    .hatching-wrapper :global(a.nft-card) {
        cursor: pointer;
    }

    .hatching-wrapper :global(a.nft-card:hover) {
        transform: translateY(-4px);
        box-shadow: 0 8px 10px rgba(160, 174, 192, 0.2);
    }

    @-webkit-keyframes jello {
        from, 11.1%, to {
            -webkit-transform: none;
            transform: none;
        }

        22.2% {
            -webkit-transform: skewX(-12.5deg) skewY(-12.5deg);
            transform: skewX(-12.5deg) skewY(-12.5deg);
        }

        33.3% {
            -webkit-transform: skewX(6.25deg) skewY(6.25deg);
            transform: skewX(6.25deg) skewY(6.25deg);
        }

        44.4% {
            -webkit-transform: skewX(-3.125deg) skewY(-3.125deg);
            transform: skewX(-3.125deg) skewY(-3.125deg);
        }

        55.5% {
            -webkit-transform: skewX(1.5625deg) skewY(1.5625deg);
            transform: skewX(1.5625deg) skewY(1.5625deg);
        }

        66.6% {
            -webkit-transform: skewX(-0.78125deg) skewY(-0.78125deg);
            transform: skewX(-0.78125deg) skewY(-0.78125deg);
        }

        77.7% {
            -webkit-transform: skewX(0.390625deg) skewY(0.390625deg);
            transform: skewX(0.390625deg) skewY(0.390625deg);
        }

        88.8% {
            -webkit-transform: skewX(-0.1953125deg) skewY(-0.1953125deg);
            transform: skewX(-0.1953125deg) skewY(-0.1953125deg);
        }
    }

    .jello {
        -webkit-animation: jello 1s both infinite;
        -webkit-transform-origin: center;
    }

    .hatching-wrapper {
        min-height: 460px;
        position: relative;
    }

    .image {
        background: linear-gradient(180deg, #3E2929 -72.66%, #0B0E21 132.58%);
        height: 205px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        padding-bottom: 18px;
    }

    .hatching-wrapper :global(.big-nft-card .image) {
        height: 278px;
    }

    .level {
        position: absolute;
        top: 0;
        right: 0;
        font-size: 15px;
        color: white;
        font-family: 'Anton', sans-serif;
        line-height: 1;
        padding: 9px 15px 0 0;
        text-align: right;
        width: 50%;
        height: 33px;
    }

    .hatching-wrapper :global(.big-nft-card .level) {
        font-size: 16px;
        padding: 10px 15px 0 0;
    }

    .level:before {
        content: "";
        width: 100%;
        height: 50px;
        background: #363a4e;
        left: 0;
        right: 0;
        top: 0;
        position: absolute;
    }

    .level:after {
        content: "";
        width: 50px;
        height: 70px;
        background: #363a4e;
        left: -12px;
        right: 0;
        top: -20px;
        position: absolute;
        transform: rotate(-20deg);
    }

    .level span {
        color: white;
        position: relative;
        z-index: 2;
    }

    .hatching-wrapper :global(.nft-card .image img) {
        max-width: 100%;
        max-height: 100%;
        padding: 10px;
        z-index: 2;
        position: relative;
    }

    .rarity {
        margin: 5px;
        position: relative;
        overflow: hidden;
    }

    .stars img {
        width: 20px;
        height: 20px;
    }

    .hatching-wrapper :global(.big-nft-card .stars img) {
        width: 25px;
        height: 25px;
        margin: 0 1px;
    }

    .hatching-wrapper :global(.big-nft-card .stars .plus) {
        width: 16px;
        height: 16px;
    }

    .stars .plus {
        width: 12px;
        height: 12px;
        margin-left: -2px;
    }

    .nft-img {
        position: relative;
        width: 100%;
        height: 100%;
        max-height: 530px;
        max-width: 530px;
        object-fit: contain;
        padding: 80px;
        transform: matrix3d(1,-.03,0,.0004,.03,1,-.05,0,0,.05,1,0,5,0,-20,1) scale(0.95);
        transition: .5s;
    }

    .nft-img:hover {
        transform: matrix3d(1,.03,0,-.0004,-.03,1,.05,0,0,-.05,1,0,-5,0,20,1) scale(1.05);
    }

    .hatching-wrapper .nft-img,
    .hatching-wrapper .nft-img:hover {
        transform: none;
    }

    .egg-crash-wrapper {
        overflow: hidden;
    }

    .egg-crash-wrapper :global(.crash) {
        padding: 0;
        margin: -2px;
        width: calc(100% + 4px);
        transform: none;
    }

    .stars img {
        width: 30px;
        height: 30px;
        margin: 0 2px;
    }

    .stars .plus {
        width: 18px;
        height: 18px;
        margin-left: -1px;
    }

    .elements img {
        width: 40px;
        height: 40px;
        margin-right: 10px;
    }

    .hatching-wrapper :global(.big-nft-card .elements img) {
        width: 45px;
        height: 45px;
        margin: -5px 2px 0 0;
    }

    .elements img:last-child {
        margin-right: 0;
    }

    .rarity-value {
        padding: 10px 15px;
        position: relative;
        color: white;
        font-size: 13px;
        font-weight: 500;
        line-height: 1;
        height: 33px;
    }

    .rarity:before {
        content: "";
        border-radius: 8px;
        width: 100%;
        height: calc(100% - 30px);
        position: absolute;
        background: #61758a;
        left: 0;
        top: 0;
    }

    .rarity-id-0:before {
        background: linear-gradient(to bottom, #66DC96 , #0B0E21);
    }

    .rarity-id-1:before {
        background: linear-gradient(to bottom, #434ACF , #0B0E21);
    }

    .rarity-id-2:before {
        background: linear-gradient(to bottom, #B644D3 , #0B0E21);
    }

    .rarity-id-3:before {
        background: linear-gradient(to bottom, #FAC50E , #0B0E21);
    }

    .rarity-id-4:before {
        background: linear-gradient(to bottom, #CF4343 , #0B0E21);
    }

    .stars {
        white-space: nowrap;
    }

    .name {
        color: white;
        font-size: 20px;
        font-weight: 500;
        padding: 6px 15px 15px;
        width: 100%;
        line-height: normal;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .hatching-wrapper :global(.big-nft-card .name) {
        font-size: 22px;
    }

    .stars {
        padding: 0 13px 6px;
        margin-top: -15px;
    }

    .stars img {
        width: 20px;
        height: 20px;
    }

    .stars .plus {
        width: 12px;
        height: 12px;
        margin-left: -2px;
    }

    .elements {
        width: 100%;
        height: 40px;
        text-align: right;
        margin: -20px 0 0;
        position: relative;
        z-index: 2;
        padding-right: 5px;
        display: flex;
        justify-content: flex-end;
    }

    .elements img {
        width: 35px;
        height: 35px;
    }

    .elements img:not(:first-child) {
        margin-left: -10px;
    }

    .flare {
        position: absolute;
        top: 0;
        height: 100%;
        width: 100px;
        transform: skewX(-35deg);
        left: -150%;
        opacity: 0.5;
        background: linear-gradient(90deg, rgba(255, 255, 255, 0.01), rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.01));
        animation: flareAnimation 2.5s infinite linear;
        z-index: 3;
    }

    .hatching-btn {
        position: absolute;
        z-index: 2;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) !important;
        margin-top: 40px;
    }

    .nft-img.jello {
        padding: 30px 100px !important;
    }

    .hatching-tooltip {
        display: inline-block;
    }

    .hatching-tooltip .tooltip {
        opacity: 0;
        visibility: hidden;
        background: #61758a;
        font-size: 14px;
        color: white;
        bottom: 50px;
        line-height: 1.2;
        padding: 5px 10px;
        transform: translateX(-50%);
        margin-left: 10px;
        min-width: 250px;
        text-align: left;
        border-radius: 3px;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.15);
        transition: opacity .2s, bottom .2s;
    }

    .hatching-info-icon {
        width: 18px;
        vertical-align: top;
        margin: 3px 0 0;
    }

    .hatching-tooltip .tooltip:after {
        content: "";
        position: absolute;
        border: 8px solid transparent;
        border-top: 8px solid #61758a;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        z-index: 2;
    }

    .hatching-tooltip:hover .tooltip {
        display: block;
        opacity: 1;
        visibility: visible;
        bottom: 40px;
    }

    @keyframes flareAnimation {
        0% {
            left: -400%;
        }
        100% {
            left: 400%;
        }
    }

    @media(max-width: 1400px) {
        .price span {
            font-size: 46px;
        }

        .stars img {
            width: 26px;
            margin: 0 2px;
        }

        .level {
            font-size: 22px;
        }
    }

    @media(max-width: 1199px) {
        .nft-img {
            max-width: 320px;
            max-height: 320px;
        }

        .stars img {
            width: 22px;
            margin: 0;
        }

        .price span {
            font-size: 36px;
        }

        .history-table-row > div {
            padding: 10px;
            font-size: 14px;
        }

        .nft-img.jello {
            padding: 30px 100px !important;
            max-width: 100%;
            max-height: 100%;
        }
    }

    @media(max-width: 991px) {
        .nft-img {
            max-width: 300px;
            max-height: 300px;
        }

        .nft-img.jello {
            padding: 30px 80px !important;
            max-width: 100%;
            max-height: 100%;
        }
    }

    @media(max-width: 767px) {
        .nft-img {
            max-width: 100%;
            max-height: 100%;
            padding: 25px;
            transform: none;
        }

        .price span {
            font-size: 30px;
        }

        .level {
            font-size: 20px;
        }

        .elements img {
            width: 30px;
            height: 30px;
        }

        .rarity-value {
            padding: 6px 10px;
            font-size: 14px;
        }

        .hatching-wrapper :global(.big-nft-card .rarity-value) {
            padding: 12px 15px;
            font-size: 16px;
            height: 40px;
        }

        .nft-img:hover {
            transform: none;
        }

        .nft-img.jello {
            height: calc(100vw - 70px);
            padding: 30px 0 !important;
            max-height: 340px;
        }

        .nft-img.crash {
            padding: 10px 0 !important;
        }

        .match-text {
            font-size: 16px;
        }

        .hatching-tooltip {
            display: block;
        }

        .hatching-tooltip .tooltip {
            transform: none;
            margin-left: 0;
        }

        .hatching-btn {
            margin-top: 0;
        }

        .egg-crash-wrapper :global(.crash) {
            min-width: calc(100% + 4px);
        }

        .hatching-wrapper {
            min-height: 380px;
            padding-bottom: 60px;
        }

        .hatching-wrapper :global(.big-nft-card) {
            width: 100%;
        }
    }
</style>
